export enum FormFieldLabel {
  ASSIGNMENT_INSTRUCTIONS = 'Assignment Instructions'
}
